import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const BadgeLink = styled(Link)`
  display: inline-flex;
  cursor: pointer;

  &,
  &:hover,
  &:focus,
  &:active,
  &:visited {
    color: inherit;
    text-decoration: none;
  }

  &::before,
  &:hover::before {
    content: none;
    display: none;
    width: 0 !important;
  }

  wa-badge {
    transition: opacity 0.15s;
  }

  &:hover wa-badge {
    opacity: 0.85;
  }
`;
